export default "__VITE_ASSET__Bh55ThxA__"